<template>
  <div class="house-importer-add-old-accounts-panel">
    <app-panel title="Шаблоны старых аккаунтов">
      <div slot="actions">
        <app-button color="success" :disabled="isSaving" @click="saveTemplates">{{isSaving ? 'Сохраняю...' : 'Сохранить'}}</app-button>
      </div>

      <div>
        <div v-for="(template,  index) in rows" :key="index" class="house-importer-add-old-accounts-panel__block">
          <div class="house-importer-add-old-accounts-panel__block-header">Шаблон №{{index+1}}</div>

          <div class="house-importer-add-old-accounts-panel__row" v-for="(row,  rowIndex) in template" :key="rowIndex">
            <div class="house-importer-add-old-accounts-panel__col">
              <app-input v-model="row.value" label="value"/>
            </div>
            <div class="house-importer-add-old-accounts-panel__col">
              <app-input v-model="row.length" vtype="uint" label="Длина"/>
            </div>
            <div class="house-importer-add-old-accounts-panel__col house-importer-add-old-accounts-panel__col_button" @click="deleteRow(index,rowIndex)">
              <app-icon name="TrashIcon" size="18px"/>
            </div>
          </div>
          <div class="house-importer-add-old-accounts-panel__add-row">
            <span class="link-icon" @click="addNewRow(index)">Добавить строку</span>
          </div>
        </div>

        <div class="house-importer-add-old-accounts-panel__add-row">
          <span class="link-icon" @click="addNewTemplate">Добавить шаблон</span>
        </div>

        <div class="house-importer-add-old-accounts-panel__info">
          <div>value может быть числом или pod - номер подъезда или number - номер помещения</div>
          <div>Длина - длина до которой исле будет увеличено нулями слева</div>
        </div>
      </div>
    </app-panel>
  </div>
</template>

<script>
  export default {
    name: "AddOldAccountsPanel",
    props: {
      importInfo: {}
    },
    data(){
      return {
        isSaving: false,
        newRow: {
          value: null,
          length: null
        },
        rows: []
      }
    },
    methods: {
      addNewTemplate(){
        this.rows.push([Object.assign({}, this.newRow)]);
      },
      addNewRow(index){
        this.rows[index].push(Object.assign({}, this.newRow));
      },
      resetRows(){
        this.rows = [[Object.assign({}, this.newRow)]];
      },
      deleteTemplate(index){
        this.rows.splice(index, 1);
        if(!this.rows.length){
          this.resetRows();
        }
      },
      deleteRow(index, rowIndex){
        this.rows[index].splice(rowIndex, 1);
        if(!this.rows[index].length){
          this.deleteTemplate(index);
        }
      },
      async getTemplates(){
        try{
          let {data} = await this.$http.get('import/houses/accounts_templates', {params: {import_id: this.importInfo.id}});
          this.rows = data || [];

          if(!this.rows.length){
            this.resetRows();
          }
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }
      },
      async saveTemplates(){
        let rows = this.rows.filter(v => v.filter(row => row.value !== null).length === v.length);
        this.isSaving = true;

        try{
          let body = {
            import_id: this.importInfo.id,
            templates: JSON.stringify(rows)
          };
          await this.$http.post('import/houses/create_old_accounts', body);
          this.$vs.notify({color: 'success', title: 'Успешное обновление', text: 'Шаблоны обновлены'});
          this.getTemplates();
          setTimeout(() => {
            this.isSaving = false;
          }, 300)
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }

      }
    },
    created(){
      this.getTemplates();
    }
  }
</script>

<style lang="scss">

  .house-importer-add-old-accounts-panel{

    &__block{
      border-bottom: 1px solid rgba(var(--app-heading-color), .4);
      padding-bottom: 10px;
      margin-bottom: 15px;

      &-header{
        display: flex;
        align-items: center;
        position: relative;
        font-weight: 500;
        color: rgba(var(--app-heading-color), 1);
        margin-bottom: 20px;

        &::after{
          content: "";
          display: block;
          flex: 1;
          width: 100%;
          height: 1px;
          margin: 0 0 0 5px;
          background: rgba(var(--app-heading-color), .4);
        }
      }
    }

    &__row{
      display: flex;
      align-items: center;
      margin: 0 -7.5px;
      margin-bottom: 15px;
    }

    &__add-row{
      margin-top: -10px;
      margin-bottom: 15px;
      text-align: center;

      &>span{
        text-transform: uppercase;
        font-size: 10px;
      }
    }

    &__col{
      padding: 0 7.5px;
      flex: 1;


      &_button{
        flex: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 17px;

        &:hover{
          cursor: pointer;
          color: rgba(var(--app-danger), 1);
        }
      }
    }

    &__info{
      text-align: center;
      line-height: 1.1;
      font-size: 12px;
      color: rgba(var(--app-text-muted),1);
    }
  }

</style>